/// <reference path="../../meevoMessenger.module.ts" />

module Meevo.Plugins.Controls {
    class SelectClientModalController {

        static $inject = ["modalTitle", "handleConfirm", "transferData", "duplicateUsers", "phoneNumber", "$mdDialog"]

        public modalTitle: any;
        public handleConfirm: any;
        public transferData: string | [string];
        public selectedUser;
        public duplicateUsers: Meevo.Model.ClientListItem | Meevo.Model.Employee;
        public phoneNumber: string;

        constructor(modalTitle: string,
                    handleConfirm: any,
                    transferData: string | [string],
                    duplicateUsers: Meevo.Model.ClientListItem | Meevo.Model.Employee,
                    phoneNumber: string,
                    private $mdDialog: angular.material.IDialogService) {



            this.handleConfirm = handleConfirm;
            this.modalTitle = modalTitle;
            this.transferData = transferData;
            this.duplicateUsers = duplicateUsers;
            this.phoneNumber = phoneNumber;
        }

        apply = () => {
            this.handleConfirm(this.transferData, this.selectedUser);
            this.$mdDialog.hide();
        }

        cancel = () => {
            this.$mdDialog.hide();
        }
    }

    angular.module("meevo.plugins.meevoMessenger")
        .controller("meevo.plugins.SelectClientModalController", SelectClientModalController);
}
